import { FEATURE_FLAG_KLARNA } from '@config/feature-flag';
import useKlarnaPlacement from '@components/product/ProductBuyZone/Klarna/useKlarnaPlacement';
import KlarnaScript from '@components/product/ProductBuyZone/Klarna/KlarnaScript';
import { useEffect, useState } from 'react';

export type KlarnaPlacementProps = {
  placement: string;
  className?: string;
  purchaseAmount: string | null | undefined;
  locale: string | undefined;
};

export default function KlarnaPlacement({
  className = '',
  placement,
  purchaseAmount,
  locale,
}: KlarnaPlacementProps) {
  // Let klarna when it's ready to render
  const ref = useKlarnaPlacement(purchaseAmount, locale);
  const [height, setHeight] = useState(0);

  useEffect(() => {
    const id = setTimeout(() => {
      if (ref?.current?.offsetHeight && ref?.current?.offsetHeight > 0) {
        setHeight(ref?.current?.offsetHeight);
      }
    }, 800);
    return () => clearTimeout(id);
  }, [ref]);

  // Do nothing if klarna is off
  if (!FEATURE_FLAG_KLARNA) return null;

  // Convert to micro units
  const microUnits = purchaseAmount?.split(' ')[0]?.replace(/[^0-9]/g, '');

  // Dont render an invalid placement as it wont fix on update
  if (typeof microUnits !== 'string' || (locale !== 'en' && locale !== 'fr')) {
    return <KlarnaScript />;
  }

  const style =
    height > 0 && parseInt(microUnits) > 3500 ? { minHeight: height } : {};

  return (
    <>
      <KlarnaScript />
      <div ref={ref} style={style} className={className}>
        <klarna-placement
          key={`${locale}-${microUnits}-${placement}`}
          data-key={placement}
          data-locale={`${locale}-CA`}
          data-purchase-amount={
            placement !== 'info-page' ? microUnits : undefined
          }
        />
      </div>
    </>
  );
}
